class ComponentCountdown extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    this.countdownActive = false;

    this.days = this.dataset.days;
    this.fallbackText = this.dataset.fallbackText;
    this.textColor = this.dataset.textColor;
    this.showCta = this.dataset.showCta === "true";
    this.ctaText = this.dataset.ctaText;
    this.ctaTextColor = this.dataset.ctaTextColor;
    console.log(this.ctaTextColor);
    this.ctaBackground = this.dataset.ctaBackground;
    this.link = this.dataset.link;
    this.fallbackLink = this.dataset.fallbackLink;

    this.now = new Date();
    const year = new Date().getFullYear();
    const month = new Date().getMonth() + 1;
    const firstOfNextMonth = new Date(year, month, 1, 0, 0, 0);
    this.endOfMonthDate = new Date(firstOfNextMonth.getTime() - 1000);
    this.startDate = new Date(
      this.endOfMonthDate.getTime() - this.days * 24 * 60 * 60 * 1000
    );

    this.countdownActive =
      (this.endOfMonthDate - this.now) / (1000 * 60 * 60 * 24) < this.days;
  }

  connectedCallback() {
    // Handle dynamic content

    this.shadowRoot.innerHTML = `
            <style>
                :host {
                  --countdown-text-color: ${this.textColor};
                  --countdown-cta-text-color: ${this.ctaTextColor};
                  --countdown-cta-background: ${this.ctaBackground};
                }
                .countdown-banner {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  padding: 10px 20px;
                  color: black;
                  text-align: center;
                  gap: 15px;
                  text-decoration: none;
                }
                
                .countdown-content {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 10px;
                }
                .countdown-cta {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  background-color: var(--countdown-cta-background);
                  color: var(--countdown-cta-text-color);
                  padding: 0.25rem 1rem;
                  border-radius: 8px;
                  margin-left: 0.5rem;
                }

                @media screen and (max-width: 767px) {
                  .countdown-content {
                    flex-direction: column;
                  }
                  .countdown-cta {
                    margin-left: 0;
                  }
                }
                
                /* Textbereich */
                .countdown-text {
                  /* font-size: 18px; */
                  color: var(--countdown-text-color);
                  white-space: nowrap;
                }
                
                /* Countdown-Timer */
                .countdown-timer {
                  display: flex;
                  align-items: center;
                  /*font-size: 18px;*/
                  gap: 2px;
                }
            </style>
            ${
              this.countdownActive && this.link
                ? `
            <a href="${this.link}" class="countdown-banner">
            `
                : this.fallbackLink
                ? `
            <a href="${this.fallbackLink}" class="countdown-banner text-decoration--none">
            `
                : `
            <div class="countdown-banner">
            `
            }
                <div class="countdown-content">
                    ${
                      this.countdownActive
                        ? `
                    <span class="countdown-text">
                        ${this.dataset.title}
                    </span>
                    `
                        : ""
                    }
                    <div class="countdown-timer">
                        <slot name="fallback"></slot>
                        <slot name="countdown"></slot>
                    </div>
                    ${
                      this.showCta
                        ? `<div class="countdown-cta">${this.ctaText}</div>`
                        : ""
                    }
                </div>
            ${
              (this.countdownActive && this.link) ||
              (!this.countdownActive && this.fallbackLink)
                ? `
            </a>
            `
                : `
            </div>
            `
            }
        `;

    this.updateCountdown();
  }

  updateCountdown() {
    const now = Date.now();
    const timeUntilEnd = this.endOfMonthDate.getTime() - now;
    const daysInMs = this.days * 24 * 60 * 60 * 1000;

    if (timeUntilEnd > 0 && timeUntilEnd < daysInMs) {
      // We are in the final N days of the month
      this.countdownActive = true;
      this.renderNormal();

      // Clear any previous interval
      if (this._intervalId) clearInterval(this._intervalId);

      // Start a new interval for updating every second
      this._intervalId = setInterval(() => {
        this.renderNormal();
      }, 1000);
    } else {
      // Not within the last N days or already past
      this.countdownActive = false;
      this.renderFallback();
    }
  }

  renderNormal() {
    const now = Date.now();
    const timeLeft = this.endOfMonthDate.getTime() - now;

    if (timeLeft <= 0) {
      // Time is up! We’ve reached or passed the end of the month.
      clearInterval(this._intervalId);
      this.renderFallback();
      return;
    }

    // Helper function to add leading zeros
    const formatNumber = (number) => number.toString().padStart(2, "0");

    // Calculate days, hours, minutes, seconds from `timeLeft`
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    if (timeLeft < 0) {
      clearInterval(this._countdownBannerInterval);
    }

    const countdown = this.shadowRoot.querySelector('slot[name="countdown"]');

    countdown.innerHTML = `
            <style>
                .time {
                    display: flex;
                }
                .time-holder {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  gap: 0;
                  width: 45px;
                }
                
                .time-data {
                  font-weight: bold;
                  line-height: 1;
                  transition: transform 0.2s ease, color 0.2s ease;
                  color: var(--countdown-text-color);
                }
                
                .time-label {
                  font-weight: 400;
                  font-size: 10px;
                  letter-spacing: -0.02em;
                  color: var(--countdown-text-color);
                }
                
                .time-separator {
                  font-weight: bold;
                  margin: 0 3px;
                  line-height: 1;
                  color: var(--countdown-text-color);
                  display: flex;
                  align-items: start;
                }
            </style>
            <div slot="countdown" class="time">
                <div class="time-holder">
                    <span class="time-data" id="countdown-days">${formatNumber(
                      days
                    )}</span>
                    <span class="time-label">Tage</span>
                </div>
                <span class="time-separator">:</span>
                <div class="time-holder">
                    <span class="time-data" id="countdown-hours">${formatNumber(
                      hours
                    )}</span>
                    <span class="time-label">Stunden</span>
                </div>
                <span class="time-separator">:</span>
                <div class="time-holder">
                    <span class="time-data" id="countdown-minutes">${formatNumber(
                      minutes
                    )}</span>
                    <span class="time-label">Minuten</span>
                </div>
                <span class="time-separator">:</span>
                <div class="time-holder">
                    <span class="time-data" id="countdown-seconds">${formatNumber(
                      seconds
                    )}</span>
                    <span class="time-label">Sekunden</span>
                </div>
            </div>
        `;
  }

  renderFallback() {
    const fallback = this.shadowRoot.querySelector('slot[name="fallback"]');

    fallback.innerHTML = `
          <style>
            .title {
                margin: 0;
                color: var(--countdown-text-color);
            }
          </style>
          <div slot="fallback"><p class="title">${this.fallbackText}</p></div>
        `;
  }
}

customElements.define("countdown-banner", ComponentCountdown);
